import { useRef, useEffect } from "react";
import "./MessageModal.css";
import DefaultAvatar from "../../assets/images/Avatar.png";
import InitialsCircle from "../../components/InitialsCircle";
import CloseIcon from "../../assets/icons/close-2hite.svg";

const MessageModal = ({
  isOpen,
  onClose,
  message,
  avatar = DefaultAvatar,
  empName,
}) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  const handleOverlayClick = (event) => {
    if (event.target === overlayRef.current) {
      onClose();
    }
  };
  if (!isOpen) return null;

  return (
    <div
      ref={overlayRef}
      className="message-modal-overlay"
      onClick={handleOverlayClick}
    >
      <div className="message-modal-close" onClick={onClose}>
        <div className="outside-btn-wrap" onClick={() => onClose()}>
          <img src={CloseIcon} alt="" />
          <div className="esc-wrap">Esc</div>
        </div>
      </div>
      <div
        className="message-modal-wrapper"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="message-modal-main">
          <div className="message-modal-avatar-wrap">
            <InitialsCircle fullName={empName} size={36} />
          </div>
          <div className="message-modal-bubble">
            <div className="message-text">{message}</div>
          </div>
        </div>
        <button className="message-modal-done-btn" onClick={onClose}>
          Done
        </button>
      </div>
    </div>
  );
};

export default MessageModal;
